import React from 'react';
import '../template-file-css/document-file-template.css';


export const NWBH_flAnnualPsychosocialHistory = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='NWBH_flAnnualPsychosocialHistory' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h4>Presenting Problem(s)</h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Describe presenting problem(s) (include information from referral source, legal
                        representative and/or family, regarding current symptoms, behaviors, and stressors):</span>
                    <textarea id='txt_1' name='txt_1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe Onset of problem(s), age or when the problem(s) begin:</span>
                    <textarea id='txt_2' name='txt_2' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Behavior/Symptom Checklist</h4></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please check behaviors and symptoms that regularly occur:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_3' name='cb_3' className='add-only' value='1' />Aggression
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_4' name='cb_4' className='add-only' value='1' />Alcohol dependence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_5' name='cb_5' className='add-only' value='1' />
                            Anger
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_6' name='cb_6' className='add-only' value='1' />Antisocial behavior
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_7' name='cb_7' className='add-only' value='1' />Anxiety
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_8' name='cb_8' className='add-only' value='1' />Withdrawal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_9' name='cb_9' className='add-only' value='1' />Isolation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_10' name='cb_10' className='add-only' value='1' />Depression
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_11' name='cb_11' className='add-only' value='1' />Disorientation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_12' name='cb_12' className='add-only' value='1' />Dizziness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_13' name='cb_13' className='add-only' value='1' />Drug Dependence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_14' name='cb_14' className='add-only' value='1' />Easily distracted
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_15' name='cb_15' className='add-only' value='1' />Eating disorder
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_16' name='cb_16' className='add-only' value='1' />Elevated mood
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_17' name='cb_17' className='add-only' value='1' />Fatigue
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_18' name='cb_18' className='add-only' value='1' />Gambling
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_19' name='cb_19' className='add-only' value='1' />Hallucinations
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_20' name='cb_20' className='add-only' value='1' />Heart palpitations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_21' name='cb_21' className='add-only' value='1' />High blood pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_22' name='cb_22' className='add-only' value='1' />Hopelessness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_23' name='cb_23' className='add-only' value='1' />Impulsivity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_24' name='cb_24' className='add-only' value='1' />Irritability
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_25' name='cb_25' className='add-only' value='1' />Judgment errors
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_26' name='cb_26' className='add-only' value='1' />Loneliness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_27' name='cb_27' className='add-only' value='1' />Memory loss
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_28' name='cb_28' className='add-only' value='1' />Mood swings
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_29' name='cb_29' className='add-only' value='1' />Panic attacks
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_30' name='cb_30' className='add-only' value='1' />Phobias/fears
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_31' name='cb_31' className='add-only' value='1' />Recurring thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_32' name='cb_32' className='add-only' value='1' />Sexual addiction
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_33' name='cb_33' className='add-only' value='1' />Sexual difficulties
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_34' name='cb_34' className='add-only' value='1' />Sleeping problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_35' name='cb_35' className='add-only' value='1' />Worrying
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Current Living Situation</h4></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Is the individual currently residing in a residential placement?</span>
                            <input type='radio' id='rb_36_1Yes' name='rb_36' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rb_36_1No' name='rb_36' className='add-only' value='No' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>How many times has the individual moved in the last 12 months?</span>
                            <input type='text' id='txt_37' name='txt_37' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the individual feel safe in their current living environment?</span>
                            <input type='radio' id='rb_38_1' name='txt_38' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_38_2' name='txt_38' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If No Explain:</span>
                    <textarea id='txt_39' name='txt_39' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Family History</h4></p>
                <table>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>Family Members (First Name Only)</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Gender</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Age</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Relationship</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Highest Grade Completed</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>In Household</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_40' name='txt_40' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_41' name='txt_41' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_42' name='txt_42' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_43' name='txt_43' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_44' name='txt_44' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_45_1' name='rb_45' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_45_2' name='rb_45' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_46' name='txt_46' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_47' name='txt_47' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_48' name='txt_48' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_49' name='txt_49' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_50' name='txt_50' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_51_1' name='rb_51' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_51_2' name='rb_51' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_52' name='txt_52' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_53' name='txt_53' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_54' name='txt_54' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_55' name='txt_55' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_56' name='txt_56' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_57_1' name='rb_57' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_57_2' name='rb_57' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_58' name='txt_58' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_59' name='txt_59' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_60' name='txt_60' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_61' name='txt_61' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_62' name='txt_62' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_63_1' name='rb_63' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_63_2' name='rb_63' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_64' name='txt_64' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_65' name='txt_65' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_66' name='txt_66' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_67' name='txt_67' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_68' name='txt_68' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_69_1' name='rb_69' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_69_2' name='rb_69' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_70' name='txt_70' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_71' name='txt_71' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_72' name='txt_72' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_73' name='txt_73' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_74' name='txt_74' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_75_1' name='rb_75' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_75_2' name='rb_75' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_76' name='txt_76' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_77' name='txt_77' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_78' name='txt_78' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_79' name='txt_79' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txt_80' name='txt_80' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rb_81_1' name='rb_81' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_81_2' name='rb_81' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's relationship with family/significant others (include
                        frequency of contact):</span>
                    <textarea id='txt_82' name='txt_82' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe any significant familial events the individual has experienced (e.g.,
                        relocation, divorce, separation, death, etc.):</span>
                    <textarea id='txt_83' name='txt_83' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe resources available from natural supports (include financial and
                        transportation needs)::</span>
                    <textarea id='txt_84' name='txt_84' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Developmental History (Trauma)</h4></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are there history or current traumatic circumstances?</span>
                            <input type='radio' id='rb_85_1' name='rb_85' className='add-only' value='1' /> Witnessed &nbsp;
                            <input type='radio' id='rb_85_2' name='rb_85' className='add-only' value='2' /> Experienced &nbsp;
                            <input type='radio' id='rb_85_3' name='rb_85' className='add-only' value='3' /> N/A
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Are there special, unusual, or traumatic circumstances that occurred during childhood?</span>
                    <span className='small'>If Yes, please provide additional information:</span>
                    <input type='radio' id='rb_86_1' name='rb_86' className='add-only' value='1' /> Yes &nbsp;
                    <input type='radio' id='rb_86_2' name='rb_86' className='add-only' value='2' /> No
                    <textarea id='txt_87' name='txt_87' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Has there been a history of child abuse?</span>
                            <input type='radio' id='rb_87_1' name='rb_87' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_87_2' name='rb_87' className='add-only' value='2' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, which type(s)?</span>
                            <input type='radio' id='rb_88_1' name='rb_88' className='add-only' value='1' /> Neglect &nbsp;
                            <input type='radio' id='rb_88_2' name='rb_88' className='add-only' value='2' /> Verbal &nbsp;
                            <input type='radio' id='rb_88_3' name='rb_88' className='add-only' value='3' /> Physical &nbsp;
                            <input type='radio' id='rb_88_4' name='rb_88' className='add-only' value='4' /> Sexual
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Financial Information</h4></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Is the individual currently employed?</span>
                            <input type='radio' id='rb_89_1' name='rb_89' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_89_2' name='rb_89' className='add-only' value='2' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes provide additional information:</span>
                            <input type='text' id='txt_90' name='txt_90' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What is the individual's total income?</span>
                            <input type='text' id='txt_91' name='txt_91' className='add-only' />
                        </td>
                        <td>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Does the individual recieve the following:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_92' name='cb_92' className='add-only' value='1' />Medicaid/Medicare
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_93' name='cb_93' className='add-only' value='1' />SSI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_94' name='cb_94' className='add-only' value='1' />Food Stamps
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_95' name='cb_95' className='add-only' value='1' />WIC
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_96' name='cb_96' className='add-only' value='1' />AFDC
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cb_97' name='cb_97' className='add-only' value='1' />Housing
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does the individual report being able to meet financial obligations?</span>
                    <span className='small'>If no, provide additional information.</span>
                    <input type='radio' id='rb_98_1' name='rb_98' className='add-only' value='1' /> Yes &nbsp;
                    <input type='radio' id='rb_98_2' name='rb_98' className='add-only' value='2' /> No<br />
                        <textarea id='txt_99' name='txt_99' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Educational/Vocational History</h4></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Educational - highest level achieved</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_1' name='rb_100' className='add-only' value='1' /> Grade School (K-5)
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_2' name='rb_100' className='add-only' value='2' /> Middle School
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_3' name='rb_100' className='add-only' value='3' /> High School, no diploma
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_4' name='rb_100' className='add-only' value='4' /> Diploma/GED
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_5' name='rb_100' className='add-only' value='5' /> Some College or technical school
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_6' name='rb_100' className='add-only' value='6' /> 2-year college, Associate's Degree
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_7' name='rb_100' className='add-only' value='7' /> 4-year college, Bachelor's Degree
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_8' name='rb_100' className='add-only' value='8' /> Graduate work, no degree
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_100_9' name='rb_100' className='add-only' value='9' /> Professional degree or more
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>List Highest Grade completed:</span>
                            <input type='text' id='txt_101' name='txt_101' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Educational-current enrollment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_102_1' name='rb_102' className='add-only' value='1' /> None
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_102_2' name='rb_102' className='add-only' value='2' /> Alternative Learning
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_102_3' name='rb_102' className='add-only' value='3' /> Academic School (K-12)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_102_4' name='rb_102' className='add-only' value='4' /> Vocational or Technical School
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_102_5' name='rb_102' className='add-only' value='5' /> College
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_102_6' name='rb_102' className='add-only' value='6' /> GED Program
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Literacy Level</span>
                            <input type='text' id='txt_102_1' name='txt_102_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Need for Assistive Technology</span>
                            <input type='text' id='txt_102_2' name='txt_102_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Previous Literacy reading level:</span>
                            <input type='text' id='txt_103' name='txt_103' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Current Literacy reading level:</span>
                            <input type='text' id='txt_104' name='txt_104' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Occupational</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_105_1' name='rb_105' className='add-only' value='1' /> Full-time work (35 hours/week)
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_105_2' name='rb_105' className='add-only' value='2' /> Part-time work (less than 35
                            hours/week)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_105_3' name='rb_105' className='add-only' value='3' /> Unemployed and seeking employment

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_105_4' name='rb_105' className='add-only' value='4' /> Unemployed - NOT seeking employment
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Not in labor force and not seeking due to:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_1' name='rb_106' className='add-only' value='1' /> Homemaker
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_2' name='rb_106' className='add-only' value='2' /> Student
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_3' name='rb_106' className='add-only' value='3' /> Retired

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_4' name='rb_106' className='add-only' value='4' /> Recieved
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_5' name='rb_106' className='add-only' value='5' /> Incarcerated

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_6' name='rb_106' className='add-only' value='6' /> Institutionalized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_7' name='rb_106' className='add-only' value='7' /> Court-ordered community service

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_8' name='rb_106' className='add-only' value='8' /> Structured Day Activity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_9' name='rb_106' className='add-only' value='9' /> Unpaid Vocational Rehabilitation

                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_10' name='rb_106' className='add-only' value='10' /> Volunteer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_106_11' name='rb_106' className='add-only' value='11' /> None

                        </td>
                        <td className='w-375'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Social Relationships & Support</h4></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>How does the individual generally get along with other people? (check all
                                that apply)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_107' name='cb_107' className='add-only' value='1' /> Affectionate
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_108' name='cb_108' className='add-only' value='1' /> Shy/Withdrawn
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_109' name='cb_109' className='add-only' value='1' /> Submissive
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_110' name='cb_110' className='add-only' value='1' /> Aggressive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_111' name='cb_111' className='add-only' value='1' /> Friendly
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_112' name='cb_112' className='add-only' value='1' /> Follower
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_113' name='cb_113' className='add-only' value='1' /> Avoidant
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_114' name='cb_114' className='add-only' value='1' /> Argues often
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_115' name='cb_115' className='add-only' value='1' /> Leader
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_116' name='cb_116' className='add-only' value='1' /> Dependent
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_117' name='cb_117' className='add-only' value='1' /> Outgoing
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_118' name='cb_118' className='add-only' value='1' /> Fights
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's ability to relate to others (include family, peers,
                        authority figures):</span>
                    <textarea id='txt_118' name='txt_118' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's environmental support system (e.g., participation in
                        social groups, community/ recreational activities, etc.):</span>
                    <textarea id='txt_119' name='txt_119' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Legal History</h4></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Is the individual involved in any active court case (e.g., traffic, civil,
                                criminal)?</span>
                            <input type='radio' id='rb_120_1' name='rb_120' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_120_2' name='rb_120' className='add-only' value='2' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Is the individual currently on probation or parole?</span>
                            <input type='radio' id='rb_121_1' name='rb_121' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_121_2' name='rb_121' className='add-only' value='2' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Has the individual ever been incarcerated?</span>
                            <input type='radio' id='rb_122_1' name='rb_122' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_122_2' name='rb_122' className='add-only' value='2' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Does the individual have a legal guardian?</span>
                            <input type='radio' id='rb_123_1' name='rb_123' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_123_2' name='rb_123' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Are there other legal concerns?</span>
                    <span className='small'>If yes, provide additional information.</span>
                    <input type='radio' id='rb_124_1' name='rb_124' className='add-only' value='1' /> Yes &nbsp;
                    <input type='radio' id='rb_124_2' name='rb_124' className='add-only' value='2' /> No<br />
                        <textarea id='txt_125' name='txt_125' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>History of Arrested, Charge and Convictions:</span>
                            <input type='radio' id='rb_126_1' name='rb_126' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_126_2' name='rb_126' className='add-only' value='2' /> No
                        </td>

                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-150'><span className='eleHeader'>Date</span></td>
                        <td className='w-300'><span className='eleHeader'>Charge</span></td>
                        <td className='w-300'><span className='eleHeader'>Disposition</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_127' name='txt_127' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txt_128' name='txt_128' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txt_129' name='txt_129' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_130' name='txt_130' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txt_131' name='txt_131' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txt_132' name='txt_132' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_133' name='txt_133' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txt_134' name='txt_134' className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='text' id='txt_135' name='txt_135' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Name and phone number of attorney and/or probation officer (if applicable):</span>
                    <textarea id='txt_136' name='txt_136' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Type of Legal Assistance:</span>
                            <input type='text' id='txt_137' name='txt_137' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Name and phone number of attorney and/or Para-legal (if applicable):</span>
                    <textarea id='txt_138' name='txt_138' className='add-only'></textarea>
                </p>
                <h3>Financial Resource</h3>
                <p className='w-750'>
                    <span className='eleHeader'>Indentify financial need:</span>
                    <textarea id='txt_139' name='txt_139' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Referral to:</span>
                            <input type='text' id='txt_140' name='txt_140' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Number:</span>
                            <input type='text' id='txt_141' name='txt_141' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Substance Use/Abuse History</h4></p>
                <table>
                    <tr>
                        <td className='w-325'>
                            <span className='eleHeader'>Substance</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>Age at 1st Use</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Frequency of Use</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Last Use</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txt_142' name='txt_142' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txt_143' name='txt_143' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txt_144' name='txt_144' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txt_145' name='txt_145' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txt_146' name='txt_146' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txt_147' name='txt_147' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txt_148' name='txt_148' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txt_149' name='txt_149' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txt_150' name='txt_150' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txt_151' name='txt_151' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txt_152' name='txt_152' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txt_153' name='txt_153' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's motivation for use:</span>
                    <textarea id='txt_154' name='txt_154' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's interest in reducing use and attaining abstinence:</span>
                    <textarea id='txt_155' name='txt_155' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe problems usage may have caused (e.g., loss of job, family dysfunction,
                        family violence, arrest, loss of friends, etc.):</span>
                    <textarea id='txt_156' name='txt_156' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Previous Inpatient and Outpatient Substance Abuse Treatment Providers</h4></p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Service</span>
                        </td>
                        <td className='w-275'>
                            <span className='eleHeader'>Provider Name</span>
                        </td>
                        <td className='w-260'>
                            <span className='eleHeader'>Service Type</span>
                        </td>
                        <td className='w-80'>
                            <center><span className='eleHeader'>Signed Release</span></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_157' name='txt_157' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_158' name='txt_158' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_159' name='txt_159' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_160' name='cb_160' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_161' name='txt_161' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_162' name='txt_162' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_163' name='txt_163' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_164' name='cb_164' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_165' name='txt_165' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_166' name='txt_166' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_167' name='txt_167' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_168' name='cb_168' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individuals response to previous substance abuse treatment:</span>
                    <textarea id='txt_169' name='txt_169' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Medical History</h4></p>
                <table>
                    <tr>
                        <td className='w-370'>
                            <span className='eleHeader'>Provider</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Last Visit</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Phone</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Signed Release</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-370'>
                            <input type='text' id='txt_170' name='txt_170' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txt_171' name='txt_171' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_172' name='txt_172' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_173' name='cb_173' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                </table>


                <p className='w-750'><h4>Most Recent Examinations</h4></p>


                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Type of Examination</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Date</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>Notes</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Physical</td>
                        <td className='w-150'>
                            <input type='date' id='txt_175' name='txt_175' className='add-only' />
                        </td>
                        <td className='w-450'>
                            <input type='text' id='txt_176' name='txt_176' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Dental</td>
                        <td className='w-150'>
                            <input type='date' id='txt_177' name='txt_177' className='add-only' />
                        </td>
                        <td className='w-450'>
                            <input type='text' id='txt_178' name='txt_178' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Vision</td>
                        <td className='w-150'>
                            <input type='date' id='txt_179' name='txt_179' className='add-only' />
                        </td>
                        <td className='w-450'>
                            <input type='text' id='txt_180' name='txt_180' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>Prenatal Exposure (drugs, Alcohol)</td>
                        <td className='w-150'>
                            <input type='date' id='txt_181' name='txt_181' className='add-only' />
                        </td>
                        <td className='w-450'>
                            <input type='text' id='txt_182' name='txt_182' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Medical Diseases/Disorders</h4></p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Condition</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Symptoms</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Treating Provider</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Signed Release</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_183' name='txt_183' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_184' name='txt_184' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_185' name='txt_185' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_186' name='cb_186' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_187' name='txt_187' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_188' name='txt_188' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_189' name='txt_189' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_190' name='cb_190' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_191' name='txt_191' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_192' name='txt_192' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_193' name='txt_193' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_194' name='cb_194' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_195' name='txt_195' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_196' name='txt_196' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_197' name='txt_197' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_198' name='cb_198' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Psychiatric History</h4></p>
                <p className='w-750'>
                    <span className='eleHeader'>Describe previous psychiatric history (include onset, symptoms, previous treatment):</span>
                    <textarea id='txt_199' name='txt_199' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>How many times has the individual been hospitalized within the last 12 months?</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>When was the individual's last clinical assessment?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_200' name='txt_200' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txt_201' name='txt_201' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>What was the primary diagnosis?</span>
                            <input type='text' id='txt_202' name='txt_202' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'><h4>Previous Inpatient and Outpatient Treatment Providers</h4></p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Date of Service</span>
                        </td>
                        <td className='w-260'>
                            <span className='eleHeader'>Provider Name</span>
                        </td>
                        <td className='w-260'>
                            <span className='eleHeader'>Service Type</span>
                        </td>
                        <td className='w-80'>
                            <span className='eleHeader'>Signed Release</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_203' name='txt_203' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_204' name='txt_204' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_205' name='txt_205' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_206' name='cb_206' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_207' name='txt_207' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_208' name='txt_208' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_209' name='txt_209' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_210' name='cb_210' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_211' name='txt_211' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_212' name='txt_212' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_213' name='txt_213' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_214' name='cb_214' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_215' name='txt_215' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_216' name='txt_216' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_217' name='txt_217' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_218' name='cb_218' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_219' name='txt_219' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_220' name='txt_220' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_221' name='txt_221' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_221' name='cb_221' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_222' name='txt_222' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_223' name='txt_223' className='add-only' />
                        </td>
                        <td className='w-260'>
                            <input type='text' id='txt_224' name='txt_224' className='add-only' />
                        </td>
                        <td className='w-80'>
                            <center><input type='checkbox' id='cb_225' name='cb_225' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Describe the individual's response to previous mental health treatment:</span>
                    <textarea id='txt_226' name='txt_226' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Current Medications (Psychiatric Medications)</h4></p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Medication</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Dosage</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Route</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Frequency</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Side Effects/Efficacy</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_227' name='txt_227' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_228' name='txt_228' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_229' name='txt_229' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_230' name='txt_230' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_231' name='txt_231' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_232' name='txt_232' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_233' name='txt_233' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_234' name='txt_234' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_235' name='txt_235' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_236' name='txt_236' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_237' name='txt_237' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_238' name='txt_238' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_239' name='txt_239' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_240' name='txt_240' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_241' name='txt_241' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_243' name='txt_243' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_244' name='txt_244' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_245' name='txt_245' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_246' name='txt_246' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_247' name='txt_247' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_248' name='txt_248' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_249' name='txt_249' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_250' name='txt_250' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_251' name='txt_251' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_252' name='txt_252' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_253' name='txt_253' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_254' name='txt_254' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_255' name='txt_255' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_256' name='txt_256' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_257' name='txt_257' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_258' name='txt_258' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_259' name='txt_259' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_260' name='txt_260' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_261' name='txt_261' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_262' name='txt_262' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_263' name='txt_263' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_264' name='txt_264' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_265' name='txt_265' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_266' name='txt_266' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_267' name='txt_267' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_268' name='txt_268' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_269' name='txt_269' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_270' name='txt_270' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_271' name='txt_271' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_272' name='txt_272' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txt_273' name='txt_273' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_274' name='txt_274' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_275' name='txt_275' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_276' name='txt_276' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_277' name='txt_277' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is the individual compliant with medication treatment regimen?</span>
                            <input type='radio' id='rb_278_1' name='rb_278' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_278_1No' name='rb_278' className='add-only' value='1' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List any known environmental, food, or medication allergies:</span>
                    <textarea id='txt_279' name='txt_279' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Common Mental Health Treatment Provider(s) & Involved Agencies</h4></p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>Start Date</span>
                        </td>
                        <td className='w-190'>
                            <span className='eleHeader'>Agency/Provider Name</span>
                        </td>
                        <td className='w-190'>
                            <span className='eleHeader'>Service Type</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Phone #</span>
                        </td>
                        <td className='w-70'>
                            <center><span className='eleHeader'>Signed Release</span></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_280' name='txt_280' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_282' name='txt_282' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_283' name='txt_283' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_284' name='txt_284' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cb_285' name='cb_285' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_286' name='txt_286' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_287' name='txt_287' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_288' name='txt_288' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_289' name='txt_289' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cb_290' name='cb_290' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_291' name='txt_291' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_292' name='txt_292' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_293' name='txt_293' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_294' name='txt_294' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cb_295' name='cb_295' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='date' id='txt_296' name='txt_296' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_297' name='txt_297' className='add-only' />
                        </td>
                        <td className='w-190'>
                            <input type='text' id='txt_298' name='txt_298' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id='txt_299' name='txt_299' className='add-only' />
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cb_300' name='cb_300' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Provide additional infromation regarding agency involvement:</span>
                    <textarea id='txt_301' name='txt_301' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Strengths</h4></p>
                <p className='w-750'>
                    <span className='eleHeader'>List current and potential strengths (e.g., skills, personality traits,
                        intelligence, resiliency, insight, etc.):</span>
                    <textarea id='txt_302' name='txt_302' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Risk Factors</h4></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_303' name='cb_303' className='add-only' value='1' />Homicidal/Assaultive
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_304' name='cb_304' className='add-only' value='1' />Physical Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_305' name='cb_305' className='add-only' value='1' />Medication Noncompliance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_306' name='cb_306' className='add-only' value='1' />Suicidal/Self Harm
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_307' name='cb_307' className='add-only' value='1' />Domestic Violence
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_308' name='cb_308' className='add-only' value='1' />Cognitive Impairment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_309' name='cb_309' className='add-only' value='1' />Neglect
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_310' name='cb_310' className='add-only' value='1' />Legal Issues
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_311' name='cb_311' className='add-only' value='1' />Inappropriate Sexual Behavior
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_312' name='cb_312' className='add-only' value='1' />Sexual Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_313' name='cb_313' className='add-only' value='1' />Trauma
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_314' name='cb_314' className='add-only' value='1' />Substance Use/Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_315' name='cb_315' className='add-only' value='1' />Emotional Abuse
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_316' name='cb_316' className='add-only' value='1' />Homelessness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cb_317' name='cb_317' className='add-only' value='1' />Other
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Provide additional information regarding identified risk factors:</span>
                    <textarea id='txt_318' name='txt_318' className='add-only'></textarea>
                </p>
                <h3>Impairments</h3>
                <h4>Identify impairments in life domains as a result of the recipient's mental and medical disorder(s). Select
                    the proper AREA and then PROVIDE A BRIEF DESCRIPTION OF IMPAIRMENT (only if checked).</h4>
                <p className='w-750'>
                    <input type='checkbox' id='cb_319' name='cb_319' className='add-only' value='1' />
                    Health (e.g., physical condition, activities of daily living)<br />
                        <textarea id='txt_320' name='txt_320' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_323' name='cb_323' className='add-only' value='1' />
                    Daily Activities (e.g., work, school, leisure)<br />
                        <textarea id='txt_324' name='txt_324' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_327' name='cb_327' className='add-only' value='1' />
                    Social Relationships (e.g., significant other, family, friends, support system)<br />
                        <textarea id='txt_328' name='txt_328' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_331' name='cb_331' className='add-only' value='1' />
                    Living Arrangement (e.g., homeless, maintaining current housing situation)<br />
                        <textarea id='txt_332' name='txt_332' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cb_334' name='cb_334' className='add-only' value='1' />
                    Speech, Language, Hearing or Vision Impairment<br />
                        <textarea id='txt_335' name='txt_335' className='add-only'></textarea>
                </p>
                <p className='w-750'><h4>Sexual Orientation, Gender Identity & Expression</h4></p>
                <p className='w-750'>The next two sections may be skipped depending on the age and maturity of the client</p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sexual Orientation?</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_337_1' name='rb_337' className='add-only' value='1' /> Heterosexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_337_2' name='rb_337' className='add-only' value='2' /> Homosexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_337_3' name='rb_337' className='add-only' value='3' /> Bisexual
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_337_4' name='rb_337' className='add-only' value='4' /> Asexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_337_5' name='rb_337' className='add-only' value='5' /> Pansexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_337_6' name='rb_337' className='add-only' value='6' /> Questioning
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Gender Identity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rb_338_1' name='rb_338' className='add-only' value='1' /> Transgender
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rb_338_2' name='rb_338' className='add-only' value='2' /> Gender Neutral/Fluid
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Preferred Pronoun:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_339_1' name='rb_339' className='add-only' value='1' /> He/Him/His
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_339_2' name='rb_339' className='add-only' value='2' /> She/Her/Hers
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rb_339_3' name='rb_339' className='add-only' value='3' /> They/Them/Theirs
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rb_339_4' name='rb_339' className='add-only' value='4' /> Other
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rb_340_1' name='rb_340' className='add-only' value='1' /> Prefers not to answer this
                            question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rb_340_2' name='rb_340' className='add-only' value='2' /> Name Prefered to be called? :&nbsp;
                            <input type='text' id='txt_341' name='txt_341' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sexually Active?</span>
                            <input type='radio' id='rb_341_1' name='rb_341' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_341_2' name='rb_341' className='add-only' value='2' /> No &nbsp;
                            <input type='radio' id='rb_341_3' name='rb_341' className='add-only' value='3' /> Prefers not to answer this question.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Does the client have a reasonable (age appropriate) understanding of what 'safe-sex' means?</span>
                            <input type='radio' id='rb_342_1' name='rb_342' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_342_2' name='rb_342' className='add-only' value='2' /> No
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, does the client participate in 'safe-sex'all of the time?</span>
                            <input type='radio' id='rb_343_1' name='rb_343' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_343_2' name='rb_343' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>If yes, what methods?</span>
                            <input type='text' id='txt_344' name='txt_344' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>If client does engage in unsafe sexual practices, has the client ever
                                been tested for STDs? </span>
                            <input type='radio' id='rb_345_1' name='rb_345' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_345_2' name='rb_345' className='add-only' value='2' /> No
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>If yes, when and where?</span>
                    <textarea id='txt_346' name='txt_346' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Any history of contracting a STD?</span>
                            <input type='radio' id='rb_347_1' name='rb_347' className='add-only' value='1' /> Yes &nbsp;
                            <input type='radio' id='rb_347_2' name='rb_347' className='add-only' value='2' /> No &nbsp;
                            <input type='radio' id='rb_347_3' name='rb_347' className='add-only' value='3' /> Prefers not to answer this question
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    If yes, please make sure it was listed in the medical portion of assessment.
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Does the client have an interest in being tested for STDs? </span>
                    <input type='radio' id='rb_348_1' name='rb_348' className='add-only' value='1' /> Yes<br /> &nbsp;
                        <input type='radio' id='rb_348_2' name='rb_348' className='add-only' value=' 2' />No<br />
                            <input type='radio' id='rb_349_1' name='rb_349' className='add-only' value='1' /> Prefers not to answer this section<br />
                                <input type='radio' id='rb_349_2' name='rb_349' className='add-only' value='2' /> Not age appropriate
                            </p>

                            
                            <table>
                                <tr>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_350' name='cb_350' className='add-only' value='1' />Mental Health Resources
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_351' name='cb_351' className='add-only' value='1' />Substance Abuse Resources
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_352' name='cb_352' className='add-only' value='1' />Medical Resources
                                    </td>
                                </tr>

                                <tr>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_353' name='cb_353' className='add-only' value='1' />Dental Resources
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_354' name='cb_354' className='add-only' value='1' />Housing
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_355' name='cb_355' className='add-only' value='1' />Food
                                    </td>
                                </tr>

                                <tr>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_356' name='cb_356' className='add-only' value='1' />Clothing
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_357' name='cb_357' className='add-only' value='1' />Transportation
                                    </td>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_358' name='cb_358' className='add-only' value='1' />Financial Resources
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-250'>
                                        <input type='checkbox' id='cb_359' name='cb_359' className='add-only' value='1' />Environmental Supports
                                    </td>
                                </tr>
                            </table>


                            <p className='w-750'>
                                <span className='eleHeader'>Other</span>
                                <textarea id='txt_360' name='txt_360' className='add-only'></textarea>
                            </p>
                            <p className='w-750'><h4>Home Visit Assessment (Mandatory Prior to the completion of the assessment):</h4></p>
                            <table>
                                <tr>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Home Visit Completion Date:</span>
                                        <input type='text' id='txt_361' name='txt_361' className='add-only' />
                                    </td>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Location of Home Visit</span>
                                        <input type='text' id='txt_362' name='txt_362' className='add-only' />
                                    </td>
                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>Note: If Home Visit is Made at Location Other Than Client's Primary Residence,
                                    Please Explain Why:</span>
                                <textarea id='txt_363' name='txt_363' className='add-only'></textarea>
                            </p>
                            <p className='w-750'>
                                Present during home visit:
                            </p>
                            <table>
                                <tr>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Name</span>

                                    </td>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Relationship</span>

                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-375'>
                                        <input type='text' id='txt_364' name='txt_364' className='add-only' />
                                    </td>
                                    <td className='w-375'>
                                        <input type='text' id='txt_365' name='txt_365' className='add-only' />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-375'>
                                        <input type='text' id='txt_366' name='txt_366' className='add-only' />
                                    </td>
                                    <td className='w-375'>
                                        <input type='text' id='txt_367' name='txt_367' className='add-only' />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-375'>
                                        <input type='text' id='txt_368' name='txt_368' className='add-only' />
                                    </td>
                                    <td className='w-375'>
                                        <input type='text' id='txt_369' name='txt_369' className='add-only' />
                                    </td>
                                </tr>
                            </table>
                            <p className='w-750'>Condition of the home</p>
                            <p className='w-750'>
                                <span className='eleHeader'>Adequate Number of Beds for Number Person Living in the Home? (comment below)</span>
                                <input type='radio' id='rb_371' name='rb_371' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_371_2' name='rb_371' className='add-only' value='2'  /> No<br />
                                    <textarea id='txt_372' name='txt_372' className='add-only'></textarea>
                            </p>
                            <table>
                                <tr>
                                    <td className='w-750'></td>
                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>Adequate Food? (comment below)</span>
                                <input type='radio' id='rb_373_1' name='rb_373' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_373_2' name='rb_373' className='add-only' value='2' /> No<br />
                                    <textarea id='txt_374' name='txt_374' className='add-only'></textarea>
                            </p>
                            <table>
                                <tr>
                                    <td className='w-750'></td>
                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>Was the Home Clean and Neat? (comment below)</span>
                                <input type='radio' id='rb_375_1' name='rb_375' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_375_2' name='rb_375' className='add-only' value='2' /> No<br />
                                    <textarea id='txt_376' name='txt_376' className='add-only'></textarea>
                            </p>
                            <p className='w-750'>
                                <span className='eleHeader'>Were there Adequate Cooking Utensils? (comment below)</span>
                                <input type='radio' id='rb_377_1' name='rb_377' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_377_2' name='rb_377' className='add-only' value='2' /> No
                                <textarea id='txt_378' name='txt_378' className='add-only'></textarea>
                            </p>
                            <p className='w-750'>
                                <span className='eleHeader'>Appropriate Heating/Air? (comment below)</span>
                                <input type='radio' id='rb_379_1' name='rb_379' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_379_2' name='rb_379' className='add-only' value='2' /> No<br />
                                    <textarea id='txt_380' name='txt_380' className='add-only'></textarea>
                            </p>
                            <p className='w-750'>
                                <span className='eleHeader'>Pets in the Home? (identify below)</span>
                                <input type='radio' id='rb_381_1' name='rb_381' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_381_2' name='rb_381' className='add-only' value='2' /> No<br />
                                    <textarea id='txt_382' name='txt_382' className='add-only'></textarea>
                            </p>
                            <table>
                                <tr>
                                    <td className='w-750'></td>
                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>Safety and Adequate Security Present? (comment below)</span>
                                <input type='radio' id='rb_383_1' name='rb_383' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_383_2' name='rb_383' className='add-only' value='2' /> No<br />
                                    <textarea id='txt_384' name='txt_384' className='add-only'></textarea>
                            </p>
                            <p className='w-750'><h4>Transportation Needs</h4></p>
                            <table>
                                <tr>
                                    <td className='w-750'>
                                        <span className='eleHeader'>Does the client or Family have Acess to Public or Personal
                                            Transportation?</span>
                                        <input type='radio' id='rb_385_1' name='rb_385' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_385_2' name='rb_385' className='add-only' value='2' /> No
                                    </td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td className='w-750'>
                                        <span className='eleHeader'>If Yes, Transportation Type?</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-187'>
                                        <input type='radio' id='rb_386_1' name='rb_386' className='add-only' value='1' /> Personal Car
                                    </td>
                                    <td className='w-187'>
                                        <input type='radio' id='rb_386_2' name='rb_386' className='add-only' value='2' /> Public
                                    </td>
                                    <td className='w-187'>
                                        <input type='radio' id='rb_386_3' name='rb_386' className='add-only' value='3' /> Friend
                                    </td>
                                    <td className='w-187'>
                                        <input type='radio' id='rb_386_4' name='rb_386' className='add-only' value='4' /> Medicaid
                                    </td>
                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>Client Long Term View</span>
                                <textarea id='txt_387' name='txt_387' className='add-only'></textarea>
                            </p>
                            <p className='w-750'><h4>Recommendation Overall Assessment of Client's Needs (All needed services to be included in the treatment and/or service plan)</h4></p>

                            <table>
                                <tr>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Mental Health Maintnance</span>
                                        <input type='radio' id='rb_388_1' name='rb_388' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_388_2' name='rb_388' className='add-only' value='2' /> No
                                    </td>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Substance Abuse Intervention</span>
                                        <input type='radio' id='rb_389_1' name='rb_389' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_389_2' name='rb_389' className='add-only' value='2' /> No
                                    </td>
                                </tr>

                                <tr>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Medical Compliance</span>
                                        <input type='radio' id='rb_390_1' name='rb_390' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_390_2' name='rb_390' className='add-only' value='2' /> No
                                    </td>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Psychiatric Services</span>
                                        <input type='radio' id='rb_391_1' name='rb_391' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_391_2' name='rb_391' className='add-only' value='2' /> No
                                    </td>
                                </tr>

                                <tr>
                                    <td className='w-750'>
                                        <span className='eleHeader'>Housing</span>
                                        <input type='radio' id='rb_392_1' name='rb_392' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_392_2' name='rb_392' className='add-only' value='2' /> No
                                    </td>
                                </tr>
                            </table>


                            <table>
                                <tr>
                                    <td className='w-250'>
                                        <span className='eleHeader'>ICD 10/DSM V Code:</span>
                                        <input type='text' id='txt_393' name='txt_393' className='add-only' />
                                    </td>
                                    <td className='w-250'>
                                        <span className='eleHeader'>Nomenclature</span>
                                        <input type='text' id='txt_394' name='txt_394' className='add-only' />
                                    </td>
                                    <td className='w-250'>
                                        <span className='eleHeader'>GAF Score:</span>
                                        <input type='text' id='txt_395' name='txt_395' className='add-only' />
                                    </td>
                                </tr>
                            </table>
                            <p className='w-750'><h4>Client Personal Safety Information</h4></p>

                            <p className='w-750'>
                                <span className='eleHeader'>Any Major Concerns or Issues Regarding Gender Preference of Service
                                    Provider: (explain below)</span>
                                <input type='radio' id='rb_396_1' name='rb_396' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_396_2' name='rb_396' className='add-only' value='2' /> No
                                <textarea id='txt_402' name='txt_402' className='add-only'></textarea>
                            </p>

                            <p className='w-750'>
                                <span className='eleHeader'>Any Special Issues or Experiences regarding Culture, Beliefs, Diet,
                                    Physical Appearance: (explain below)</span>
                                <input type='radio' id='rb_397_1' name='rb_397' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_397_2' name='rb_397' className='add-only' value='2' /> No
                                <textarea id='txt_403' name='txt_403' className='add-only'></textarea>
                            </p>

                            <p className='w-750'>
                                <span className='eleHeader'>Knowledge of Any Physical Problem, Medical Condition or Disabilities
                                    that may be helpful in Case of an Emergency: (explain below)</span>
                                <textarea id='txt_404' name='txt_404' className='add-only'></textarea>
                            </p>
                            <table>
                                <tr>
                                    <td className='w-750'>
                                        <span className='eleHeader'>Any Conditions or Actions that make You Extremely Upset or
                                            Uncomfortable: :</span>
                                        <input type='radio' id='rb_399_1' name='rb_399' className='add-only' value='1' /> Yes &nbsp;
                                        <input type='radio' id='rb_399_2' name='rb_399' className='add-only' value='2' /> No
                                    </td>

                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>In What Environment are you Most Comfortable (alone, crowds, public,
                                    secluded, open etc.):</span>
                                <textarea id='txt_400' name='txt_400' className='add-only'></textarea>
                            </p>
                            <table>
                                <tr>
                                    <td className='w-750'></td>
                                </tr>
                            </table>
                            <p className='w-750'>
                                <span className='eleHeader'>Are You Sensitive about Others Knowing Your Challenges: (explain below)</span>
                                <input type='radio' id='rb_401_1' name='rb_396' className='add-only' value='1' /> Yes &nbsp;
                                <input type='radio' id='rb_401_2' name='rb_396' className='add-only' value='2' /> No<br />
                                    <textarea id='txt_405' name='txt_405' className='add-only'></textarea>
                            </p>
                            <p className='w-750'>
                                <span className='eleHeader'>Comprehensive Summary:</span>
                                <textarea id='txt_406' name='txt_406' className='add-only'></textarea>
                            </p>
                            <p className='w-750'><h4>Referrals:</h4></p>
                            <table>
                                <tr>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Agencies</span>
                                    </td>
                                    <td className='w-375'>
                                        <span className='eleHeader'>Phone Number</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-375'>
                                        <input type='text' id='txt_407' name='txt_407' className='add-only' />
                                    </td>
                                    <td className='w-375'>
                                        <input type='text' id='txt_408' name='txt_408' className='add-only' />
                                    </td>
                                </tr>
                                <tr>
                                    <td className='w-375'>
                                        <input type='text' id='txt_409' name='txt_409' className='add-only' />
                                    </td>
                                    <td className='w-375'>
                                        <input type='text' id='txt_410' name='txt_410' className='add-only' />
                                    </td>
                                </tr>
                            </table>
                            <table>
                                <tr>
                                    <td className='w-750'>
                                        <span className='eleHeader'>Discharge/Aftercare Planning Information:</span>
                                        <input type='text' id='txt_411' name='txt_412' className='add-only' />
                                    </td>
                                </tr>
                            </table>
                            <p className='w-750'><h4>Summary</h4></p>
                            <p className='w-750'>To be completed by Targeted Case Manager</p>
                            <p className='w-750'>
                                <input type='radio' id='rb_412_1' name='rb_412' className='add-only' value='1' /> Date(s) of Home Visit(s): &nbsp;
                                <input type='text' id='txt_413' name='txt_413' className='add-only w-350 custom-add-only' />
                            </p>
                            <p className='w-750'>
                                <input type='radio' id='rb_412_2' name='rb_412' className='add-only' value='2' /> Face-to-face interview not
                                conducted in the home. Please provide justification explaining why the home visit could not be made:<br />
                                    <textarea id='txt_413Justification' name='txt_413Justification' className='add-only'></textarea>
                            </p>

                        </div>
                    </form>

                    )
}

